import * as React from "react";
import { useRecaptcha } from "@grandvisionhq/forms";
const getName = (formState) => {
  const firstName = formState.firstName?.value || "";
  const lastName = formState.lastName?.value || "";
  return `${firstName} ${lastName}`.trim();
};
const getReason = (formState) => {
  const data = formState["topic-list"]?.value;
  if (data && data.key) {
    return data.key;
  }
  return "";
};
const useSubmit = () => {
  const [data, setData] = React.useState(void 0);
  const { getToken } = useRecaptcha();
  const onSubmit = React.useCallback(async ({ formState, formValid }) => {
    try {
      const token = await getToken();
      if (formValid) {
        setData({
          recaptchaToken: token,
          ticketInput: {
            name: getName(formState),
            email: formState.email?.value || "",
            phoneNumber: formState.phone?.value || "",
            customerID: formState.customerID?.value || "",
            subject: "",
            description: formState.description?.value || "",
            reason: getReason(formState)
          }
        });
      }
    } catch (error) {
      console.error("Recaptcha", error);
    }
  }, []);
  const reset = React.useCallback(() => {
    setData(void 0);
  }, []);
  const actions = React.useMemo(() => ({ onSubmit, reset }), [onSubmit, reset]);
  return [data, actions];
};
export {
  useSubmit
};
//# sourceMappingURL=use-submit.js.map
